module.exports = __webpack_public_path__ + "static/media/NABJ_BG_V2.a43c2bc5.jpg";